import { areAddressesEqual } from 'src/common/utils/web3/areAddressesEqual'
import { KNOWN_TOKENS } from '../tokens/known-tokens'

export const getKnownToken = (contractAddress: string, chainId: number) => {
  return Object.values(KNOWN_TOKENS[chainId]).find(knownToken =>
    areAddressesEqual(contractAddress, knownToken.contractAddress)
  )
}
